import classNames from 'classnames/bind';
import React from 'react';

import ButtonLink from 'reactComponents/buttonLink';
import { BasicField, BasicFieldProps } from 'reactComponents/Forms/_BasicField';
import { _BasicFieldError } from 'reactComponents/Forms/_BasicFieldError/_BasicFieldError';
import { Input } from 'reactComponents/Input/Input';

import styles from './FieldCaptcha.css';

const css = classNames.bind(styles);

type Props = Omit<BasicFieldProps, 'control'> & {
    url?: string;
};

type State = {
    formedUrl?: string;
};

export class FieldCaptcha extends React.PureComponent<Props, State> {
    state: State = {
        formedUrl: this.props.url
            ? this._makeNoCacheCaptchaUrl(this.props.url)
            : '',
    };

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (prevProps.url === this.props.url) {
            return;
        }

        if (this.props.url) {
            this._setUrl();
        } else {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ formedUrl: '' });
        }
    }

    _makeNoCacheCaptchaUrl(url: string) {
        return `${url}?${Date.now()}`;
    }

    _setUrl = () => {
        this.setState({
            formedUrl: this._makeNoCacheCaptchaUrl(this.props.url || ''),
        });
    };

    render() {
        return this.state.formedUrl ? (
            <BasicFieldCaptcha
                {...this.props}
                onRefresh={this._setUrl}
                url={this.state.formedUrl}
            />
        ) : null;
    }
}

const BasicFieldCaptcha = ({ ...otherInputProps }) => {
    return (
        // @ts-ignore
        <BasicField
            {...{
                control: CaptchaControl,
                hideErrorAtField: true,
                autoComplete: 'off',
                ...otherInputProps,
            }}
        />
    );
};

const CaptchaControl = ({ url, onRefresh, ...props }) => {
    return (
        <div className={css('root')}>
            <div className={css('leftPart')}>
                <div className={css('inputWrapper')}>
                    <Input
                        placeholder="Введите код с картинки"
                        {...props}
                        error={!!props.error}
                        className={css('input')}
                    />

                    {_renderError(props.error)}

                    <ButtonLink
                        className={css('refreshButton')}
                        onClick={onRefresh}
                    >
                        Не вижу код
                    </ButtonLink>
                </div>
            </div>
            <div className={css('rightPart')}>
                <img className={css('img')} src={url} alt="" />
            </div>
        </div>
    );
};

const _renderError = (error?: string) => {
    if (error) {
        return (
            <div className={css('error')}>
                <_BasicFieldError dataTest="captcha-errors">
                    {error}
                </_BasicFieldError>
            </div>
        );
    }
    return null;
};
